<script setup lang="ts">
import { useSlots, computed } from 'vue';

const props = defineProps<{
    submittedFilters: string[];
}>();

useSlots();

const numQuestionsLabel = computed(() => (props.submittedFilters.length > 0 ? `(${props.submittedFilters.length})` : ''));

</script>
<template>
    <div>
        <q-btn
            class="quiz-filter-button outline-gray"
            color="black"
            icon="filter_alt"
            dense
            flat
            square
            size="12px"
            aria-label="open status filter menu"
            tabindex="0"
        >
            <div class="label">
                {{ numQuestionsLabel }}
            </div>
            <slot />
        </q-btn>
    </div>
</template>
<style scoped lang="scss">
:deep(.q-btn .q-icon) {
    font-size: 18px;
}
</style>
<style lang="scss">
.quiz-filter-button .on-left {
    margin-right: 2px;
}
</style>
